import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../services/api';

export const postNotification = createAsyncThunk(
  'notification/postNotificaiton',
  async (notification) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/notice/',
        method: 'POST',
        data: notification,
      });
      return response?.status;
    } catch (error) {
      return error.response.status;
    }
  },
);
export const updateNotification = createAsyncThunk(
  'notification/updateNotificaiton',
  async (notification) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/notice/',
        method: 'PUT',
        data: notification,
      });
      return response.status;
    } catch (error) {
      console.log(error);
    }
  },
);

export const getNotifications = createAsyncThunk(
  'notification/getNotificaiton',
  async () => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/notice/',
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const deleteNotification = createAsyncThunk(
  'notification/deleteNotificaiton',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/notice/${id}`,
        method: 'DELETE',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
const notificationSlice = createSlice({
  name: 'notifications',
  initialState: [],
  reducers: {},
});
export default notificationSlice.reducer;
